import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout.js";
import { UniversePage } from "./pages/UniversePage.js";
import { CorrelationPage } from "./pages/CorrelationPage.js";
import { AccumulatorPage } from "./pages/AccumulatorPage.js";
import { FcnPage } from "./pages/FcnPage.js";
import { HistoricalPage } from "./pages/HistoricalPage.js";
import { AdminPage } from "./pages/AdminPage.js";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/universe" replace />} />
        <Route path="/universe" element={<UniversePage />} />
        <Route path="/correlation" element={<CorrelationPage />} />
        <Route path="/accumulator" element={<AccumulatorPage />} />
        <Route path="/fcn" element={<FcnPage />} />
        <Route path="/historical" element={<HistoricalPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}
